import React, { FC } from 'react'
import { Switch as HeadlessSwitch } from '@headlessui/react'
import classNames from 'classnames'
import { CaptionSM } from '@/atoms/Text'

export interface SwitchProps {
  label: string
  checked: boolean
  onChange: (enabled: boolean) => void
}

export const Switch: FC<SwitchProps> = ({ checked, label, onChange }) => {
  return (
    <HeadlessSwitch
      checked={checked}
      onChange={onChange}
      className={classNames(
        'relative inline-flex flex-shrink-0 h-6 w-16 text-[11px] items-center rounded-full py-2 px-2 uppercase',
        checked ? 'bg-oxide-primary' : 'bg-core-gray-400',
      )}
    >
      <CaptionSM
        className={classNames(checked ? 'translate-x-0.25' : 'translate-x-6')}
        color={checked ? 'white' : 'core-gray-950'}
      >
        {label}
      </CaptionSM>
      <span
        aria-hidden="true"
        className={`${
          checked
            ? 'translate-x-5 border border-solid border-oxide bg-[#1FBF94]'
            : '-translate-x-7 border border-solid border-[#778086] bg-white'
        }
            inline-block h-4 w-4 rounded-full bg-white transition`}
      />
    </HeadlessSwitch>
  )
}
